"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuPanelContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./index.scss");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function MenuPanelContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const color = data.color,
    gradientColor = data.gradientColor;
  const bgStyle = {};
  if (color) {
    bgStyle['backgroundColor'] = color;
  }
  if (gradientColor) {
    bgStyle['backgroundImage'] = gradientColor;
  }
  const renderChild = child => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains: domainInfos,
      className: 'component-banner-offset-top'
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "banner-offset-container",
    id: "banner-offset-container",
    style: bgStyle
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("div", {
    className: "banner-offset-child",
    style: commonStyle,
    key: index,
    id: `banner-offset-container-child-${index}`
  }, renderChild(child))));
}